import { sourceChannels } from "@/mocks/homeContent";

export default function Sources() {
  return (
    <section id="sources" className="w-full bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-8">
        <div className="max-w-2xl">
          <span className="inline-flex items-center gap-2 text-sm font-medium text-primary-700">
            <span className="h-px w-6 bg-primary-600"></span> 投稿与信息来源
          </span>
          <h2 className="mt-3 font-display text-2xl font-bold tracking-tight text-foreground-950 md:text-4xl">
            多元渠道，按需选投
          </h2>
          <p className="mt-4 text-base leading-relaxed text-foreground-600">
            无论是完整素材还是一手原件，都能在对应渠道中得到妥善处理。每一条路径均配备清晰受理规则与保密承诺。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-4">
          {sourceChannels.map((c) => (
            <div
              key={c.title}
              className="flex flex-col rounded-lg border border-background-200 bg-background-100/60 p-6 transition-colors hover:border-secondary-300"
            >
              <span className="flex h-11 w-11 items-center justify-center rounded-md bg-secondary-100 text-secondary-800">
                <i className={`${c.icon} text-xl`}></i>
              </span>
              <h3 className="mt-4 font-display text-lg font-bold text-foreground-950">{c.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{c.desc}</p>
              <ul className="mt-4 space-y-2 border-t border-background-200 pt-4">
                {c.points.map((p) => (
                  <li key={p} className="flex items-center gap-2 text-sm text-foreground-700">
                    <i className="ri-checkbox-circle-fill text-accent-500"></i>
                    {p}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}